import {useEffect, useMemo, useRef, useState} from 'react'
import {useLayout} from '../../../../_metronic/layout/core'
import {KTCard, KTCardBody, KTIcon, useDebounce, formatNumber} from '../../../../_metronic/helpers'
import {ColumnInstance, Row, useTable} from 'react-table'
import Select from 'react-select'
import clsx from 'clsx'
import {getRegisterValues} from './api'
import {getSalesAndPurchaseColumns} from './Columns'
import toast from 'react-hot-toast'
import * as XLSX from 'xlsx'
import {Loader} from '../../product-master/loader'
import {ErrorsPage} from '../../errors/ErrorsPage'
const SalesAndPurchaseView: React.FC<{
  activeTab: string
}> = ({activeTab}) => {
  const {company, financialYear, fyEndDate, fyStartDate} = useLayout()

  const tableRef: any = useRef(null)

  const [toDate, setToDate] = useState<string>('')
  const [fromDate, setFromDate] = useState<string>('')
  //   const [view, setView] = useState({value: 'Monthly', label: 'Monthly'})
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [data, setData] = useState<any[]>([])
  const [isDateUpdate, setIsDateUpdate] = useState(false)
  const [totalSales, setTotalSales] = useState<number>(0)
  const [totalDebit, setTotalDebit] = useState<number>(0)
  const [totalCredit, setTotalCredit] = useState<number>(0)
  const [currency, setCurrency] = useState<string>('')
  const [isButtonHovered, setIsButtonHovered] = useState(false)
  // console.log(typeof company.value)
  useEffect(() => {
    if (fyStartDate && fyEndDate) {
      setFromDate(fyStartDate)
      setToDate(fyEndDate)
    } else {
      const storedFromDate = localStorage.getItem('fromDate')
      const storedToDate = localStorage.getItem('toDate')
      if (!storedFromDate || !storedToDate) {
        const [year1, year2] = financialYear?.value.split('-')
        setFromDate(new Date(Number(year1.trim()), 3, 2).toISOString().split('T')[0])
        setToDate(new Date(Number(year2.trim()), 3, 1).toISOString().split('T')[0])
      } else {
        setFromDate(storedFromDate)
        setToDate(storedToDate)
      }
    }
    setIsDateUpdate(true)
  }, [fyStartDate, fyEndDate])

  useEffect(() => {
    if (isDateUpdate) {
      localStorage.setItem('fromDate', fromDate)
      localStorage.setItem('toDate', toDate)
    }
  }, [isDateUpdate])

  //   const debouncedFrom = useDebounce(fromDate, 1000)
  //   const debouncedTo = useDebounce(toDate, 1000)

  const columns = useMemo(
    () =>
      fromDate && toDate
        ? getSalesAndPurchaseColumns(
            activeTab,
            fromDate,
            toDate,
            // view?.value,
            totalDebit,
            totalCredit,
            currency
          )
        : [],
    [activeTab, fromDate, toDate, totalDebit, totalCredit, currency]
  )

  useEffect(() => {
    // // console.log(debouncedFrom)
    const getData = () => {
      // console.log(activeTab)
      // console.log(fromDate)
      // console.log(toDate)
      // console.log(isDateUpdate)
      if (
        company?.value &&
        financialYear?.value &&
        fromDate &&
        toDate &&
        activeTab &&
        // view?.value &&
        isDateUpdate
      ) {
        setIsError(false)
        setIsLoading(true)
        getRegisterValues(
          activeTab === 'purchase'
            ? 'purchases'
            : activeTab === 'debitnote'
            ? 'debit_note'
            : activeTab === 'creditnote'
            ? 'credit_note'
            : activeTab,
          Number(company?.value),
          financialYear.value,
          fromDate,
          toDate
          //   view.value.toLowerCase()
        )
          .then((res) => {
            res && setData(res.records)
            res && setTotalSales(res.totalSales || 0)
            res && setTotalCredit(res.totalCredit || 0)
            res && setTotalDebit(res.totalDebit || 0)
            res && setCurrency(res.currency || '')
          })
          .catch((e) => {
            e && toast.error(e.message || 'Something Went Wrong, Please try again later.')
            setData([])
            setTotalSales(0)
            setTotalCredit(0)
            setTotalDebit(0)
            setCurrency('')
            setIsError(true)
          })
          .finally(() => {
            setIsLoading(false)
            setIsDateUpdate(false)
          })
      }
    }

    getData()
  }, [activeTab, company?.value, financialYear?.value, isDateUpdate])

  const {getTableProps, getTableBodyProps, headers, rows, prepareRow, footerGroups} = useTable({
    columns,
    data,
  })

  return (
    <>
      <KTCard className='mb-5'>
        <div className='card-header border-0'>
          <div className='card-title'>
            {/* begin::Search */}
            <div className='d-flex align-items-center position-relative my-1'>
              <input
                type='date'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14 me-3'
                placeholder='Search'
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <input
                type='date'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search'
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
              <button
                type='button'
                className='btn btn-lg ms-3'
                style={{
                  borderRadius: '1000%',
                  height: '30px',
                  width: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  backgroundColor: !isButtonHovered ? '#f0f0f0' : '#b0b0b0',
                }}
                onMouseEnter={() => setIsButtonHovered(true)}
                onMouseLeave={() => setIsButtonHovered(false)}
                onClick={() => {
                  if (!fromDate || !toDate)
                    toast.error('Please make sure both the From and To dates are selected')
                  else setIsDateUpdate(true)
                }}
              >
                <KTIcon iconName='arrows-circle' className='fs-3 px-0' />
              </button>
            </div>
            {/* end::Search */}
          </div>
          {/* begin::Card toolbar */}
          <div className='card-toolbar'>
            {/* begin::Group actions */}
            {
              <div className='d-flex justify-content-end gap-3' data-kt-user-table-toolbar='base'>
                <button
                  type='button'
                  className='btn p-0'
                  style={{
                    backgroundColor: 'var(--bs-primary)',
                    color: 'var(--bs-primary-inverse)',
                    display: 'inline-flex',
                    height: '43.59px',
                    alignItems: 'center',
                    justifyContent: 'space-between',

                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  }}
                  disabled={!data.length}
                  onClick={() => {
                    toast.success('Download has been started successfully')
                    const ws = XLSX.utils.table_to_sheet(tableRef.current)

                    // Add additional data to the worksheet if needed

                    const wb = XLSX.utils.book_new()
                    XLSX.utils.book_append_sheet(wb, ws, 'ViewTransactions')

                    // Save the file
                    const fileName = `Register${company.label}_${financialYear.value}.xlsx`
                    XLSX.writeFile(wb, fileName)
                  }}
                >
                  <span className='px-5'>Download</span>
                  <span
                    style={{
                      color: '#fff',
                      backgroundColor: '#006060',
                      padding: '0 15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                      borderTopRightRadius: 'inherit',
                      borderBottomRightRadius: 'inherit',
                    }}
                  >
                    <KTIcon iconName='arrow-down' className='fs-2 text-white' />
                  </span>
                </button>
                {/* end::Add user */}
              </div>
            }
            {/* end::Group actions */}
          </div>
          {/* end::Card toolbar */}
        </div>
      </KTCard>
      <KTCard>
        <KTCardBody
          className={`py-4 ${fromDate && toDate && isDateUpdate ? 'position-relative' : ''}`}
        >
          {!isLoading && (
            <>
              <div className='table-responsive'>
                <table
                  ref={tableRef}
                  id='register_table'
                  className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
                  {...getTableProps()}
                >
                  <thead>
                    <tr
                      className='bg-light ps-4 text-uppercase gs-0 text-center'
                      style={{
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#343541',
                      }}
                    >
                      {headers.map((column: ColumnInstance<any>) => (
                        <CustomHeaderColumn key={column.id} column={column} />
                      ))}
                    </tr>
                  </thead>
                  <tbody
                    {...getTableBodyProps()}
                    className='text-center'
                    style={{
                      fontSize: '11px',
                      fontWeight: '500',
                      color: '#343541',
                    }}
                  >
                    {rows.length > 0 ? (
                      rows.map((row: Row<any>, i) => {
                        prepareRow(row)
                        return (
                          <CustomRow row={row} currency={currency} key={`row-${i}-${row.id}`} />
                        )
                      })
                    ) : (
                      <tr>
                        <td colSpan={14}>
                          <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                            No data available to show
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    {footerGroups.map((footerGroup) => (
                      <tr {...footerGroup.getFooterGroupProps()}>
                        {footerGroup.headers.map((column) => (
                          <th>{column.render('Footer')}</th>
                        ))}
                      </tr>
                    ))}
                  </tfoot>
                </table>
              </div>
              <div className='bg-light d-flex justify-content-between px-3 text-dark py-5'>
                <span
                  className='col-2 d-flex justify-content-start text-primary ps-5'
                  style={{fontSize: '12px', fontWeight: '600'}}
                >
                  Total{' '}
                  {activeTab === 'sales'
                    ? 'Sales'
                    : activeTab === 'purchase'
                    ? 'Purchases'
                    : 'Amount'}
                </span>
                <span style={{fontSize: '14px', fontWeight: '800'}}>
                  {/* {currency}  */}
                  {formatNumber(totalSales)}
                </span>
              </div>
            </>
          )}
          {isLoading && <Loader isError={isError} />}
        </KTCardBody>
      </KTCard>
    </>
  )
}

type ColProps = {
  column: ColumnInstance<any>
}

export const CustomHeaderColumn: React.FC<ColProps> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

type RowProps = {
  row: Row<any>
  currency?: string
}

export const CustomRow: React.FC<RowProps> = ({row}) => {
  return (
    <>
      <tr {...row.getRowProps()} className='bg-hover-light'>
        {row.cells.map((cell) => {
          return (
            <td
              {...cell.getCellProps()}
              className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
            >
              {cell.render('Cell')}
            </td>
          )
        })}
      </tr>
    </>
  )
}

export const styles = {
  borderRadius: '0.475rem',
  boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
  backgroundColor: '#fff',
  color: '#7e8299',
  fontWeight: '500',
  margin: '0',
  width: 'auto',
  padding: '1rem 2rem',
  top: 'calc(50% - 2rem)',
  left: 'calc(50% - 4rem)',
}

type OptionType = {
  value: string
  label: string
}

export default SalesAndPurchaseView
